import { Box, Typography, useTheme } from '@mui/material';

export type CohortBuilderViewFieldProps = {
  /**
   * @prop {string} id - id of the entry, also used are the key
   *
   */
  id: string;

  /**
   * @prop {string} label
   */
  label: string;

  /**
   * @prop {string} value
   */
  value: string;

  /**
   * @prop {string | number} width - the width of the field
   */
  width?: string | number;
};

export const CohortBuilderViewField = ({
  id,
  label,
  value,
  width,
}: CohortBuilderViewFieldProps) => {
  const theme = useTheme();

  const widthValue = typeof width === 'number' ? `${width}px` : width;

  return (
    <Box
      id={id}
      data-testid={`cohort-builder-view-field-${id}`}
      sx={{ display: 'flex', flexDirection: 'column', width: `${widthValue}` }}
    >
      <Box>
        <Typography
          variant="body2"
          sx={{
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: 1 /* number of lines to show */,
            WebkitBoxOrient: 'vertical',
          }}
        >
          {label}
        </Typography>
      </Box>
      <Box>
        <Typography
          variant="body1"
          sx={{
            fontWeight: 600,
            color: theme.palette.text.primary,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: '-webkit-box',
            WebkitLineClamp: 2 /* number of lines to show */,
            WebkitBoxOrient: 'vertical',
          }}
        >
          {value}
        </Typography>
      </Box>
    </Box>
  );
};
